import { createContext } from "react";

export interface StateWizard {
  step?: string;
  disableNextControl: boolean;
  hideBackControl: boolean;
}

export interface InitialWizard {
  state: StateWizard;
  dispatch?: () => void;
  onHandleNextEvent?: () => void;
  onHandleSubmit?: () => void;
  setTitle?: () => void;
  setSubtitle?: () => void;
  setPercent?: () => void;
}

export const initialWizardState = {
  step: undefined,
  disableNextControl: true,
  hideBackControl: true,
};

export const InitialWizardContext = {
  state: initialWizardState,
  dispatch: null,
  onHandleNextEvent: null,
  onHandleSubmit: null,
  setTitle: null,
  setSubtitle: null,
  setPercent: null,
};

export const WizardContext = createContext<InitialWizard>(InitialWizardContext);
